import React from 'react';
import { useLens } from './LensProvider';
import './Temporal.css';

const integrationDescription = (ic) => {
  if (ic > 0.5) return 'High — experiences digest easily';
  if (ic > 0.2) return 'Moderate — some experiences linger';
  return 'Low — intensity tends to echo forward';
};

const ExperienceMeter = () => {
  const { residue, integrationCapacity } = useLens();

  let status, statusColor, analogy;
  if (residue < 0.1) {
    status = 'Settled';
    statusColor = 'var(--success)';
    analogy = 'Like still water — past intensity has been absorbed.';
  } else if (residue < 0.5) {
    status = 'Integrating';
    statusColor = 'var(--accent)';
    analogy = 'Like ripples after a stone — still settling.';
  } else {
    status = 'Residue present';
    statusColor = 'var(--warning)';
    analogy = 'Like an echo in a canyon — past intensity still reverberating.';
  }

  const residueWidth = Math.min(100, residue * 20);

  return (
    <div className="temporal-container">
      <h4>Integration</h4>
      <div style={{ marginBottom: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', marginBottom: '4px' }}>
          <span style={{ color: statusColor }}>{status}</span>
          <span style={{ color: 'var(--text-dim)', fontSize: '0.75rem' }}>{integrationDescription(integrationCapacity)}</span>
        </div>
        <div style={{ background: 'var(--bg-surface)', borderRadius: '4px', height: '6px', overflow: 'hidden' }}>
          <div style={{
            width: `${residueWidth}%`,
            height: '100%',
            background: `linear-gradient(90deg, ${statusColor}, transparent)`,
            borderRadius: '4px',
            transition: 'width 0.5s ease',
          }} />
        </div>
      </div>
      <p style={{ fontSize: '0.75rem', color: 'var(--text-dim)', fontStyle: 'italic', margin: 0 }}>
        {analogy}
      </p>
    </div>
  );
};

export default ExperienceMeter;
